import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Toast } from 'react-weui';
import PropTypes from 'prop-types';
import * as MobileActions from 'actions/index.ts';
import Http from 'services/http2';
import User from 'services/user2';

import { withStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

const styles = theme => ({
  paper: {
    margin: '10px',
  },
});

class EmployeeJoin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: '',
      inviteCode: '',
      inviteCompanyCode: '',
      showLoading: false,
    };
    this.intPattern = /^\d{6}$/;
    this.intPattern2 = /^\d{8}$/;
  }

  init() {}

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {}

  handleClose = () => {
    const { actions } = this.props;
    actions.closeEmployeeJoinModal();
  };

  handleChange = event => {
    let val = event.target.value;
    this.setState({ [event.target.name]: val });
    this.setState({ errorMsg: '' });
  };

  handleOk = () => {
    if (!this.check()) {
      return;
    }
    let postbody = {
      companyCode: this.state.inviteCompanyCode,
      inviteCode: this.state.inviteCode,
      apiPath: '/archives/compEmployee/authInvite',
    };
    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
      this.setState({ showLoading: false });
      if (response.success) {
        this.props.onChange('success');
        this.handleClose();
        User.refreshUserInfo();
      } else {
        this.setState({ errorMsg: response.errorMsg });
      }
    });
  };

  check = () => {
    var result = true;
    if (!this.intPattern2.test(this.state.inviteCompanyCode)) {
      this.setState({ errorMsg: '无效的携客企业号' });
      result = false;
    }
    if (!this.intPattern.test(this.state.inviteCode)) {
      this.setState({ errorMsg: '无效的验证码' });
      result = false;
    }
    return result;
  };

  render() {
    const { classes, data } = this.props;
    return (
      <div>
        <Dialog
          classes={{ paper: classes.paper }}
          open={data.employeeJoinModal}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">员工加入公司</DialogTitle>
          <DialogContent>
            <DialogContentText>
              输入您公司管理员发给您的 企业号 以及 6位验证码
            </DialogContentText>
            <TextField
              margin="normal"
              variant="outlined"
              id="inviteCompanyCode"
              name="inviteCompanyCode"
              label="请输入企业号"
              onChange={this.handleChange}
              type="inviteCompanyCode"
              fullWidth
            />

            <TextField
              margin="normal"
              variant="outlined"
              id="inviteCode"
              name="inviteCode"
              label="请输入您收到的6位验证码"
              onChange={this.handleChange}
              type="inviteCode"
              fullWidth
            />

            {this.state.errorMsg && (
              <p className="error-tip">{this.state.errorMsg}</p>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              取消
            </Button>
            <Button onClick={this.handleOk} color="primary">
              确定
            </Button>
          </DialogActions>
        </Dialog>
        <Toast icon="loading" show={this.state.showLoading}>
          Loading...
        </Toast>
      </div>
    );
  }
}

EmployeeJoin.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.modal,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(EmployeeJoin));
